import { ApplicationInsights } from '@microsoft/applicationinsights-web';
let ai = null;
export function initializeAppInsights(instrumentationKey) {
    ai = new ApplicationInsights({
        config: {
            instrumentationKey,
            disableAjaxTracking: true,
            disableFetchTracking: true,
            disableCorrelationHeaders: true,
            autoTrackPageVisitTime: false,
        },
    });
    ai.loadAppInsights();
    ai.addTelemetryInitializer((envelope) => {
        if (envelope.baseType === 'PageviewData' || envelope.baseType === 'PageviewPerformanceData') {
            return false;
        }
        return true;
    });
    return ai;
}
